import React from 'react'
import { CoreContainer } from '@hub/core-container'
import { Text } from '@hub/text'
import { Button } from '@hub/button/src'
import { Stack } from '@hub/stack'
import { SGPageTemplateBasicContent } from '../../../../../src/types/page-templates'
import { ModuleProps } from '../types'

export default function BasicContent({
  module,
  disableContainerPadding = false,
}: ModuleProps<SGPageTemplateBasicContent> & {
  disableContainerPadding?: boolean
}): JSX.Element {
  const Wrapper = disableContainerPadding ? 'div' : CoreContainer
  return (
    <Wrapper>
      <Text
        isBodyText
        as={'h1'}
        fontSize={['font-h3', 'font-h2', 'font-h1']}
        tone="strong"
      >
        {module.title}
      </Text>
      <Text
        sx={{
          marginTop: ['spacing-sm', 'spacing-sm', 'spacing-md'],
          marginBottom: ['spacing-sm', 'spacing-sm', 'spacing-md'],
          lineHeight: 'base',
        }}
      >
        {module.bodyCopy}
      </Text>
      <Stack
        sx={{
          marginTop: 'spacing-md',
        }}
        gap={'spacing-lg'}
        direction={['column', 'row']}
      >
        {module.callsToAction.map(({ url, label }) => (
          <Button
            key={label}
            colorScheme={'licorice'}
            sx={{
              paddingY: 'spacing-lg',
              textTransform: 'uppercase',
              width: '100%',
            }}
            variant="outline"
            onClick={() => window.open(url, '_blank')}
          >
            {label}
          </Button>
        ))}
      </Stack>
    </Wrapper>
  )
}
